<template>
    <div class="aba-cliente select-modal">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column" :class="[permissaoVincular ? 'is-6' : 'is-8']">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-contato"
                    />
                </div>

                <div class="column" :class="[permissaoVincular ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastrarContato"
                    >
                        {{ $t('adicionar-contato') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <empty-table-message
                    v-else-if="!hasModuloContato"
                    msg="msg-sem-modulopda-configurado"
                />
                <b-table
                    v-else
                    :data="AssContatoClienteList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assClienteContatoIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'nome'">
                            <a
                                @click="selectedEdit(props.row)"
                                v-if="!assClienteContatoIntegracao && permissao.update"
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else-if="f.key == 'telefone'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                showPartInfoPosition="end"
                                :showPartInfoLenght="4"
                            />
                        </div>
                        <div v-else-if="f.key == 'email'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                showPartInfoPosition="end"
                                :showPartInfoLenght="4"
                            />
                        </div>
                        <div v-else-if="f.key == 'datanascimento'">
                            <HideInfo
                                v-if="!cleanHide && !isNull(props.row[f.key])"
                                :value="props.row[f.key] | moment('DD/MM/YYYY')"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                showPartInfoPosition="end"
                                :showPartInfoLenght="4"
                            />
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <ContatoModal
                        :idCliente="+$route.params.id"
                        :idContato="this.idcontato"
                        :integracao="assClienteContatoIntegracao"
                        :permissao="permissao"
                        @fecharModal="fecharModal"
                        v-if="showModalAssociacao"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import ContatoService from '@/services/vendas/cliente/abas/ContatoService';
import ContatoModal from '@/components/vendas/cliente/modal/ContatoModalManage.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        ContatoModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            assClienteContatoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'CONTATO'
            ),
            AssContatoClienteList: [],
            fields: [
                { key: 'idcontato', width: null, sortable: true, sortFn: null },
                { key: 'idcontatoerp', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'telefone', width: null, sortable: false, sortFn: null },
                { key: 'datanascimento', width: null, sortable: true, sortFn: null },
                { key: 'depto', width: null, sortable: true, sortFn: null },
                { key: 'email', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new ContatoService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            asscontatocliente: null,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            idcontato: null,
            hasModuloContato: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-contato'
            );
        } else if (this.isAgro) {
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-contato'
            );
        }

        this.hasModuloContato = this.hasModulo('CONTATO');

        this.permissaoVincular =
            this.permissao.create && !this.assClienteContatoIntegracao && this.hasModuloContato;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            if (this.hasModuloContato) {
                this.carregarDados();
                this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            }
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.AssContatoClienteList = value;
                    this.isEmpty = this.AssContatoClienteList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os contatos!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, id, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcontato: m.idcontato,
                    idcliente: m.idcliente,
                    idcontatoerp: m.idcontatoerp,
                    nome: m.nome,
                    telefone: m.telefone,
                    datanascimento: m.datanascimento,
                    depto: m.depto,
                    email: m.email,
                    cpf: m.cpf,
                    obs: m.obs,
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-cliente-contato'
                    : 'msg-erro-ao-reativar-associacao-cliente-contato';

            let tempAssClienteContato = {
                idcontato: this.delete.idcontato,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssClienteContato)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-cliente-contato'
                                : 'msg-sucesso-ao-desativar-associacao-cliente-contato';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assClienteContato) {
            if (this.isUpdate) return this.service.updateSituacaoVendas(assClienteContato);
            else return this.service.updateSituacaoAgro(assClienteContato);
        },
        showModalCadastrarContato() {
            this.idcontato = null;
            this.asscontatocliente = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.asscontatocliente = null;
            this.carregarDados();
        },
        selectedEdit(select) {
            this.idcontato = select.idcontato;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
